import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import EventsController from 'components/molecules/EventsController';
import {
	actionCreators as eventAC,
	getBadges,
	getCustomOverlays,
	getEvents,
	getFeedbacks,
	getImages,
	getLevel,
	getLevelPoints,
	getLevelUps,
	getMessages,
	getPoints,
	getProgram,
	getProgramSummaries,
	getStickers,
	getWarnings,
	RootStateType as EventsRootStateType,
} from 'store/events';
import { getIsAuthenticated } from 'store/login';
import { getLastDayOfProgram, getStartDate } from 'store/programDays';
import { RootStateType as ProgramItemsRootStateType } from 'store/programItems';
import { actionCreators as globalAC } from 'store/rootReducer';

type RootStateType = EventsRootStateType & ProgramItemsRootStateType;

const mapStateToProps = (state: RootStateType) => {
	const internalEventMap = {
		points: getPoints(state),
		programSummaries: getProgramSummaries(state),
		stickers: getStickers(state),
		images: getImages(state),
		badges: getBadges(state),
		feedbacks: getFeedbacks(state),
		warnings: getWarnings(state),
		levelUps: getLevelUps(state),
		messages: getMessages(state),
		customOverlays: getCustomOverlays(state),
	};

	return {
		isAuthenticated: getIsAuthenticated(state as any),
		events: getEvents(state),
		eventMap: internalEventMap,
		signature: ((eventMap: any) => {
			return Object.keys(eventMap)
				.map((value: any): any => `${value}:${eventMap[value].length || 0}`)
				.join(',');
		})(internalEventMap),
		level: getLevel(state),
		levelPoints: getLevelPoints(state),
		startDate: getStartDate(state),
		endDate: getLastDayOfProgram(state),
		program: getProgram(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doFlushEventByIds: eventAC.doFlushEventByIds,
			doFlushAllProgramData: globalAC.doFlushAllProgramData as any,
			doSaveCustomOverlayShown: eventAC.doSaveCustomOverlayShown,
		},
		dispatch
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(EventsController as any);
